import { render, staticRenderFns } from "./GenericServiceDesk.vue?vue&type=template&id=fb624ee0&scoped=true"
import script from "./GenericServiceDesk.vue?vue&type=script&lang=js"
export * from "./GenericServiceDesk.vue?vue&type=script&lang=js"
import style0 from "./GenericServiceDesk.vue?vue&type=style&index=0&id=fb624ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb624ee0",
  null
  
)

export default component.exports